/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path {
    fill: #DF5C4E;
  }
  .white {
    fill: #eee;
  }
`
export default class GuestIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="57" height="65" viewBox="0 0 57 65" css={Color}>
        <g id="그룹_3640" data-name="그룹 3640" transform="translate(-796.982 -629.219)">
          <path id="다각형_2" data-name="다각형 2" d="M44.683,0a7,7,0,0,1,6.081,3.533l12.259,21.5a7,7,0,0,1,0,6.934l-12.259,21.5A7,7,0,0,1,44.683,57H20.317a7,7,0,0,1-6.081-3.533L1.977,31.967a7,7,0,0,1,0-6.934l12.259-21.5A7,7,0,0,1,20.317,0Z" transform="translate(853.982 629.219) rotate(90)" fill="#df5c4e" />
          <g id="그룹_32" data-name="그룹 32" transform="translate(820.982 652.219)">
            <path id="패스_11" className="white" data-name="패스 11" d="M27.985,17.914A4.279,4.279,0,0,0,23.42,13.35c-.761,0-4.727.135-4.727,4.564l2.119,23.309a2.664,2.664,0,0,0,5.216,0Z" transform="translate(-18.694 -24.35)" fill="#eee" />
            <circle id="타원_450" className="white" data-name="타원 450" cx="4.5" cy="4.5" r="4.5" transform="translate(0.002 22)" fill="#fff" />
          </g>
        </g>
      </svg>
    )
  }
}
